(() => {
  var e = {}; // empty modules object now

  var n = {};

  function t(r) {
    var o = n[r];
    if (void 0 !== o) return o.exports;
    var i = (n[r] = { exports: {} });
    return e[r](i, i.exports, t), i.exports;
  }

  (() => {
    "use strict";

    var e = function (e) {
        if ("object" != typeof (n = e) || Array.isArray(n))
          throw "state should be an object";
        var n;
      },
      n = function (e, n, t, r) {
        return ((o = e),
        o.reduce(function (e, n) {
          return e.indexOf(n) > -1 ? e : e.concat(n);
        }, []))
          .reduce(function (e, t) {
            return e.concat(n[t] || []);
          }, [])
          .map(function (e) {
            return e(t, r);
          });
        var o;
      };

    function r(t) {
      void 0 === t && (t = {});
      var r = {};
      return {
        getState: function () {
          return Object.assign({}, t);
        },
        hydrate: function (o) {
          return (
            e(o),
            Object.assign(t, o),
            function () {
              var e = ["*"].concat(Object.keys(o));
              n(e, r, t);
            }
          );
        },
        on: function (e, n) {
          return (
            (e = [].concat(e)).map(function (e) {
              return (r[e] = (r[e] || []).concat(n));
            }),
            function () {
              return e.map(function (e) {
                return r[e].splice(r[e].indexOf(n), 1);
              });
            }
          );
        },
        emit: function (o, i, c) {
          var a = ("*" === o ? [] : ["*"]).concat(o);
          (i = "function" == typeof i ? i(t) : i) &&
            (e(i), Object.assign(t, i), (a = a.concat(Object.keys(i)))),
            n(a, r, t, c);
        },
      };
    }

    r();

    var o = function (e) {
        return "object" == typeof e && !Array.isArray(e);
      },
      i = function (e) {
        return "function" == typeof e;
      };

    const c = (function (e, n, t) {
      void 0 === e && (e = {}),
        void 0 === n && (n = {}),
        void 0 === t && (t = []);
      var c = r(n),
        a = [];
      return {
        on: c.on,
        emit: c.emit,
        getState: function () {
          return c.getState();
        },
        add: function (n) {
          if (!o(n)) throw "components should be an object";
          Object.assign(e, n);
        },
        use: function (e) {
          if (!i(e)) throw "plugins should be a function";
          t.push(e);
        },
        hydrate: function (e) {
          return c.hydrate(e);
        },
        mount: function (n) {
          void 0 === n && (n = "data-component"), (n = [].concat(n));
          for (var r = 0; r < n.length; r++) {
            for (
              var s = n[r],
                u = [].slice.call(document.querySelectorAll("[" + s + "]")),
                d = function () {
                  for (
                    var n = u.pop(), r = n.getAttribute(s).split(/\s/), d = 0;
                    d < r.length;
                    d++
                  ) {
                    var l = e[r[d]];
                    if (l) {
                      n.removeAttribute(s);
                      try {
                        var m = t.reduce(function (e, t) {
                            var r = t(n, c);
                            return o(r) ? Object.assign(e, r) : e;
                          }, {}),
                          p = l(n, Object.assign({}, m, c));
                        i(p.unmount) && a.push(p);
                      } catch (e) {
                        console.error(e),
                          c.emit("error", {
                            error: e,
                          }),
                          c.hydrate({
                            error: void 0,
                          });
                      }
                    }
                  }
                };
              u.length;

            )
              d();
            c.emit("mount");
          }
        },
        unmount: function () {
          for (var e = a.length - 1; e > -1; e--) {
            var n = a[e],
              t = n.subs;
            (0, n.unmount)(n.node),
              t.map(function (e) {
                return e();
              }),
              a.splice(e, 1);
          }
          c.emit("unmount");
        },
      };
    })({}, {});

    window.app = c;

    window.component = function (e) {
      return function (n, t) {
        var r = [];
        return {
          subs: r,
          unmount: e(
            n,
            Object.assign({}, t, {
              on: function (e, n) {
                var o = t.on(e, n);
                return r.push(o), o;
              },
            })
          ),
          node: n,
        };
      };
    };

    window.vendors = (e) => c.emit(`${e}:loaded`);

    c.on("mount", () => console.log("js is mounted"));
  })();
})();
